var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from "react";
import { Container } from "./styled/menu-link";
function MenuLink(_a) {
    var to = _a.to, className = _a.className, _b = _a.isFocused, isFocused = _b === void 0 ? false : _b, _c = _a.closeOnClick, closeOnClick = _c === void 0 ? true : _c, onClick = _a.onClick, onClose = _a.onClose, props = __rest(_a, ["to", "className", "isFocused", "closeOnClick", "onClick", "onClose"]);
    var ref = useRef();
    useEffect(function () {
        var _a;
        if (isFocused) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isFocused]);
    return (React.createElement(Container, __assign({}, props, { to: to, role: "menuitem", tabIndex: -1, ref: ref, className: "menu-item " + (isFocused ? "focused" : "") + " " + (className || ""), onClick: function (e) {
            onClick && onClick(e);
            onClose && closeOnClick && onClose();
        } })));
}
export default MenuLink;
